export default __webpack_public_path__ + "static/media/full-screen-image-3.21a228cd.jpg";